import './jquery-global'; // sets window.jQuery for the slimscroll plugin — must be first
import React from 'react'; // required in scope for the classic JSX runtime
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router, Switch, Route } from 'react-router-dom';
import { LOCATION_CHANGE } from 'react-router-redux';
import configureStore, { history } from './store';
import { initStore } from './store/instance';
import App from './containers/App';

/* eslint-disable react/jsx-filename-extension */
const store = configureStore();
initStore(store);

// ConnectedRouter (react-router-redux 5-alpha) relies on react-redux's legacy
// store context, which react-redux 6+ removed. Wire history -> store directly:
// dispatch LOCATION_CHANGE (payload = the location object, per react-router-redux's
// reducer) on the initial location and on every navigation, so routerReducer and
// the dev-overlay saga still observe navigation.
store.dispatch({ type: LOCATION_CHANGE, payload: history.location });
history.listen((location) => {
  store.dispatch({ type: LOCATION_CHANGE, payload: location });
});

const rootEl = document.getElementById('app-site');
createRoot(rootEl).render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </Provider>,
);
